module.exports = __webpack_public_path__ + "static/img/g201.1a646fff.png";